/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlHealthStatus } from './ControlHealthStatus';
import {
    ControlHealthStatusFromJSON,
    ControlHealthStatusFromJSONTyped,
    ControlHealthStatusToJSON,
} from './ControlHealthStatus';
import type { ControlIntegrationEntitlementV2 } from './ControlIntegrationEntitlementV2';
import {
    ControlIntegrationEntitlementV2FromJSON,
    ControlIntegrationEntitlementV2FromJSONTyped,
    ControlIntegrationEntitlementV2ToJSON,
} from './ControlIntegrationEntitlementV2';
import type { ControlIntegrationHealthDetailsV2 } from './ControlIntegrationHealthDetailsV2';
import {
    ControlIntegrationHealthDetailsV2FromJSON,
    ControlIntegrationHealthDetailsV2FromJSONTyped,
    ControlIntegrationHealthDetailsV2ToJSON,
} from './ControlIntegrationHealthDetailsV2';
import type { ControlIntegrationMetadataConfigV2 } from './ControlIntegrationMetadataConfigV2';
import {
    ControlIntegrationMetadataConfigV2FromJSON,
    ControlIntegrationMetadataConfigV2FromJSONTyped,
    ControlIntegrationMetadataConfigV2ToJSON,
} from './ControlIntegrationMetadataConfigV2';
import type { ControlPlatform1 } from './ControlPlatform1';
import {
    ControlPlatform1FromJSON,
    ControlPlatform1FromJSONTyped,
    ControlPlatform1ToJSON,
} from './ControlPlatform1';

/**
 * 
 * @export
 * @interface ControlIntegrationV2
 */
export interface ControlIntegrationV2 {
    /**
     * 
     * @type {ControlIntegrationMetadataConfigV2}
     * @memberof ControlIntegrationV2
     */
    config: ControlIntegrationMetadataConfigV2;
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationV2
     */
    createdAt: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlIntegrationV2
     */
    enabled: boolean;
    /**
     * 
     * @type {ControlIntegrationHealthDetailsV2}
     * @memberof ControlIntegrationV2
     */
    healthDetails: ControlIntegrationHealthDetailsV2;
    /**
     * 
     * @type {ControlHealthStatus}
     * @memberof ControlIntegrationV2
     */
    healthStatus: ControlHealthStatus;
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationV2
     */
    id: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlIntegrationV2
     */
    identityFields: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlIntegrationV2
     */
    muteHourlyQuality?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationV2
     */
    permissionUpdateExplanation: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlIntegrationV2
     */
    permissionsUpdateAvailable: boolean;
    /**
     * 
     * @type {ControlPlatform1}
     * @memberof ControlIntegrationV2
     */
    platform: ControlPlatform1;
    /**
     * 
     * @type {Array<ControlIntegrationEntitlementV2>}
     * @memberof ControlIntegrationV2
     */
    publicEntitlements: Array<ControlIntegrationEntitlementV2>;
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationV2
     */
    requiresConfiguration?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ControlIntegrationV2
     */
    sourceSystemUpdates: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationV2
     */
    teamId: string;
    /**
     * 
     * @type {string}
     * @memberof ControlIntegrationV2
     */
    teamName?: string;
}

/**
 * Check if a given object implements the ControlIntegrationV2 interface.
 */
export function instanceOfControlIntegrationV2(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "config" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "enabled" in value;
    isInstance = isInstance && "healthDetails" in value;
    isInstance = isInstance && "healthStatus" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "identityFields" in value;
    isInstance = isInstance && "permissionUpdateExplanation" in value;
    isInstance = isInstance && "permissionsUpdateAvailable" in value;
    isInstance = isInstance && "platform" in value;
    isInstance = isInstance && "publicEntitlements" in value;
    isInstance = isInstance && "sourceSystemUpdates" in value;
    isInstance = isInstance && "teamId" in value;

    return isInstance;
}

export function ControlIntegrationV2FromJSON(json: any): ControlIntegrationV2 {
    return ControlIntegrationV2FromJSONTyped(json, false);
}

export function ControlIntegrationV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlIntegrationV2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'config': ControlIntegrationMetadataConfigV2FromJSON(json['config']),
        'createdAt': json['createdAt'],
        'enabled': json['enabled'],
        'healthDetails': ControlIntegrationHealthDetailsV2FromJSON(json['healthDetails']),
        'healthStatus': ControlHealthStatusFromJSON(json['healthStatus']),
        'id': json['id'],
        'identityFields': json['identityFields'],
        'muteHourlyQuality': !exists(json, 'muteHourlyQuality') ? undefined : json['muteHourlyQuality'],
        'permissionUpdateExplanation': json['permissionUpdateExplanation'],
        'permissionsUpdateAvailable': json['permissionsUpdateAvailable'],
        'platform': ControlPlatform1FromJSON(json['platform']),
        'publicEntitlements': ((json['publicEntitlements'] as Array<any>).map(ControlIntegrationEntitlementV2FromJSON)),
        'requiresConfiguration': !exists(json, 'requiresConfiguration') ? undefined : json['requiresConfiguration'],
        'sourceSystemUpdates': json['sourceSystemUpdates'],
        'teamId': json['teamId'],
        'teamName': !exists(json, 'teamName') ? undefined : json['teamName'],
    };
}

export function ControlIntegrationV2ToJSON(value?: ControlIntegrationV2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'config': ControlIntegrationMetadataConfigV2ToJSON(value.config),
        'createdAt': value.createdAt,
        'enabled': value.enabled,
        'healthDetails': ControlIntegrationHealthDetailsV2ToJSON(value.healthDetails),
        'healthStatus': ControlHealthStatusToJSON(value.healthStatus),
        'id': value.id,
        'identityFields': value.identityFields,
        'muteHourlyQuality': value.muteHourlyQuality,
        'permissionUpdateExplanation': value.permissionUpdateExplanation,
        'permissionsUpdateAvailable': value.permissionsUpdateAvailable,
        'platform': ControlPlatform1ToJSON(value.platform),
        'publicEntitlements': ((value.publicEntitlements as Array<any>).map(ControlIntegrationEntitlementV2ToJSON)),
        'requiresConfiguration': value.requiresConfiguration,
        'sourceSystemUpdates': value.sourceSystemUpdates,
        'teamId': value.teamId,
        'teamName': value.teamName,
    };
}

